import CollectionEmbed from '@/components/ui/CollectionEmbed';
import type { ProductCarouselSection as ProductCarouselSectionType } from '@shared/lib/page-sections/types';

/**
 * Carousel-form variant of CollectionGrid. We reuse CollectionEmbed under the
 * hood because it already knows how to fetch + render a carousel, this just
 * forces the displayType to CAROUSEL and exposes a tighter set of fields.
 */
export default function ProductCarouselSection({ section }: { section: ProductCarouselSectionType }) {
  if (!section.collectionId) return null;
  return (
    <section className="w-full px-4 py-10 md:py-14">
      <div className="mx-auto max-w-7xl">
        <CollectionEmbed
          collectionId={section.collectionId}
          displayType="CAROUSEL"
          productLimit={section.productLimit ?? 12}
          title={section.title ?? null}
          showTitle={Boolean(section.title)}
        />
      </div>
    </section>
  );
}
